import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Pencil } from 'lucide-react';
import { PopoverCellEditor } from './PopoverCellEditor';

export interface CellEditButtonProps {
  onOpen: () => void;
  columnLabel: string;
  testId: string;
  className?: string;
}

export function CellEditButton({
  onOpen,
  columnLabel,
  testId,
  className = '',
}: Readonly<CellEditButtonProps>) {
  const { t } = useTranslation('general');

  return (
    <button
      type="button"
      data-testid={testId}
      aria-label={t('table.edit_column', { column: columnLabel })}
      className={`hover:text-success-500 cursor-pointer ${className}`}
      onClick={onOpen}
    >
      <Pencil size={14} aria-hidden />
    </button>
  );
}

export interface CellEditPopoverProps {
  isOpen: boolean;
  onOpen: () => void;
  onDone: () => void;
  isBusy?: boolean;
  columnLabel: string;
  testId: string;
  renderEditor: () => ReactNode;
  anchorClassName?: string;
}

export function CellEditPopover({
  isOpen,
  onOpen,
  onDone,
  isBusy = false,
  columnLabel,
  testId,
  renderEditor,
  anchorClassName,
}: Readonly<CellEditPopoverProps>) {
  return (
    <PopoverCellEditor
      isOpen={isOpen}
      onDone={onDone}
      canClose={!isBusy}
      anchor={
        <CellEditButton
          onOpen={onOpen}
          columnLabel={columnLabel}
          testId={testId}
          className={anchorClassName}
        />
      }
      editor={isOpen ? renderEditor() : null}
    />
  );
}
